module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.c8fa12a4.svg";